import { render, staticRenderFns } from "./ReasonRejection.vue?vue&type=template&id=2bc21362"
import script from "./ReasonRejection.vue?vue&type=script&lang=js"
export * from "./ReasonRejection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports